export default __webpack_public_path__ + "static/media/crees4.9044aefa.png";